import { ApiClient } from '@mypoz/shared';

const TOKEN_KEY = 'mypoz_token';

export const tokenStore = {
  get: () => localStorage.getItem(TOKEN_KEY),
  set: (token: string) => localStorage.setItem(TOKEN_KEY, token),
  clear: () => localStorage.removeItem(TOKEN_KEY),
};

/**
 * Baked in at build time. Locally it falls back to :8787; in production the deploy workflow
 * supplies it from the WEB_API_URL repository variable.
 */
export const apiBaseUrl = import.meta.env.VITE_API_URL || 'http://localhost:8787';

export const api = new ApiClient({
  baseUrl: apiBaseUrl,
  getToken: tokenStore.get,
  onUnauthorized: () => {
    tokenStore.clear();
    if (location.pathname !== '/login') location.assign('/login');
  },
});
